var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('div',[_c('a-table',{staticClass:"tableStyle",attrs:{"columns":_vm.columns,"data-source":_vm.displayStockProducts,"loading":_vm.tableLoading,"pagination":_vm.pagination}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }